import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import { OrganizationAccessControlModuleEnum, CustomerPermissionActionEnum, CustomerPermissionSubjectEnum, type components } from '@/libs/openapi/schema';
import { hasPermissions, hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

export const organizationUserApiKeyPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.API_KEY_INTEGRATION)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_USER_API_KEY, [
      CustomerPermissionActionEnum.READ,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  create: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.API_KEY_INTEGRATION)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_USER_API_KEY, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  update: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.API_KEY_INTEGRATION)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_USER_API_KEY, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
